<header></header>
<div class="pt-20" [@routeOuterAnimations]="resolveRoute(o)">
  <router-outlet #o="outlet"></router-outlet>
</div>

<loader *ngIf="loaderService.showLoader | async"></loader>